import React from 'react';
import { useSelector } from 'react-redux';

/**
 * menuInfo의 proId에 따라 다른 버전의 컴포넌트를 동적으로 선택
 *
 * @param {Object} props
 * @param {string} props.menuId - 메뉴 ID (예: 'M_Permit')
 * @param {string} props.path - 경로 타입 (예: 'list', 'write', 'detail')
 * @param {Object} props.components - 컴포넌트 매핑 (선택사항, routeConfig 사용 시 생략 가능)
 *   - default: 기본 컴포넌트
 *   - [proId]: 해당 proId일 때 사용할 컴포넌트
 */
export function DynamicRouteWrapper({ menuId, path, components }) {
  const menuInfo = useSelector((state) => state.BaseInfo.menuInfo);

  // routeConfig에서 컴포넌트 가져오기 (path가 제공된 경우)
  let componentMap = components;
  if (path && !components) {
    try {
      const { getComponent } = require('./routeConfig');
      const pathConfig = getComponent(menuId, path);
      if (pathConfig) {
        componentMap = pathConfig;
      }
    } catch (e) {
      console.warn(
        'routeConfig를 불러올 수 없습니다. components prop을 사용하세요.'
      );
    }
  }

  if (!componentMap) {
    console.error(
      `컴포넌트 매핑을 찾을 수 없습니다. menuId: ${menuId}, path: ${path}`
    );
    return null;
  }

  // menuInfo에서 해당 메뉴 찾기
  const menu = menuInfo?.find((m) => m.menuId === menuId);

  // proId를 기반으로 컴포넌트 선택

  const componentKey = menu?.proId || 'default';
  const Component = componentMap[componentKey] || componentMap.default;

  // console.log('[DynamicRouteWrapper]', {
  //   menuId,
  //   path,
  //   menuFound: !!menu,
  //   menuproId: menu?.proId,
  //   componentKey,
  //   availableKeys: Object.keys(componentMap),
  //   selectedComponent: Component?.name || 'Unknown',
  // });

  if (!Component) {
    console.error(
      `컴포넌트를 찾을 수 없습니다. menuId: ${menuId}, path: ${path}, componentKey: ${componentKey}`,
      '사용 가능한 키:',
      Object.keys(componentMap)
    );
    return null;
  }

  return <Component />;
}
